import { createTheme } from "@mui/material/styles"

const theme = createTheme({
	spacing: 8,
	palette: {
		primary: {
			// light: will be calculated from palette.primary.main,
			main: "#4691CE",
			// dark: will be calculated from palette.primary.main,
			// contrastText: will be calculated to contrast with palette.primary.main
		},
		secondary: {
			// light: will be calculated from palette.primary.main,
			main: "#263739",
			// dark: will be calculated from palette.primary.main,
			// contrastText: will be calculated to contrast with palette.primary.main
		},
		// error: will use the default color
	},
	typography: {
		fontFamily: ["Mulish"].join(","),
	},
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					size: "medium",
					typography: {
						fontFamily: ["Mulish"].join(","),
					},
				},
			},
		},
		MuiFilledInput: {
			styleOverrides: {
				root: { dense: true },
			},
		},
		MuiFormControl: {
			styleOverrides: {
				root: { dense: true },
			},
		},
		MuiFormHelperText: {
			styleOverrides: {
				root: { dense: true },
			},
		},
		MuiIconButton: {
			styleOverrides: {
				root: { size: "small" },
			},
		},
		MuiInputBase: {
			styleOverrides: {
				root: { dense: true },
			},
		},
		MuiInputLabel: {
			styleOverrides: {
				root: { dense: true },
			},
		},
		MuiListItem: {
			styleOverrides: {
				root: { dense: true },
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				root: { dense: true },
			},
		},
		MuiTable: {
			styleOverrides: {
				root: { size: "medium" },
			},
		},
		MuiTextField: {
			styleOverrides: {
				root: { dense: true },
			},
		},
		// If we want to disable the Ripples -> enable below
		// MuiButtonBase: {
		//   disableRipple: true 💣!
		// }
	},
})

export default theme
